import React, { FC, useState } from 'react';
import { toast } from 'react-toastify';
import { Button } from '../../../../components/Button';
import Modal from '../../../../components/Modal/NewModal';
import { useMemberDetails } from '../../../../hooks/useMemberDetail';
import { MemberModalProps } from '../MembersTable';
import { ButtonWithIconAndLoader } from '@td-client-frontend/common';

const MemberActivationModal: FC<MemberModalProps> = ({ isOpen, onClose, onComplete, member, setSelectedMember }) => {
  const { reactivateMember } = useMemberDetails();
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [disabledBtn, setDisabledBtn] = useState<boolean>(false);

  const handleMemberActivation = async () => {
    setDisabledBtn(true);
    setIsLoading(true);
    try {
      // @ts-ignore
      const result = await reactivateMember({ memberId: member?.mrnId });
      if (result && !result.errors?.length) {
        toast.success('Member(s) reactivated successfully', { position: 'top-center' });
        onComplete();
      } else {
        toast.error('Failed to reactivate member(s)', { position: 'top-center' });
      }
    } finally {
      onClose(false);
      setDisabledBtn(false);
      setSelectedMember(null);
      setIsLoading(false);
    }
  };

  const CustomButtons = () => {
    return (
      <div className="flex gap-4">
        <Button title="No" kind="secondary" onClick={() => onClose(false)} />
        <ButtonWithIconAndLoader
          title="Yes, reactivate"
          kind="primary"
          onClick={handleMemberActivation}
          labelClasses="pr-1"
          loading={isLoading}
          disabled={disabledBtn}
        />
      </div>
    );
  };

  return (
    <Modal
      isOpen={isOpen}
      onClose={() => onClose(false)}
      header="Reactivate"
      customFooterActions={{
        right: <CustomButtons />
      }}
      size="small"
    >
      <section className="p-6 font-bold">
        <p>
          Are you sure you want to reactivate benefits for {member?.firstName} {member?.lastName}?
        </p>
      </section>
    </Modal>
  );
};

export default MemberActivationModal;
